import React from 'react';
import './Chats.css'
import Chat from './Chat'

const Chats = () => {
    return (
        <div>
            <Chat 
                name="Mary"
                message="done with it"
                timestamp="2 minutes ago"
                profilePic="https://images.pexels.com/photos/4197491/pexels-photo-4197491.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            />
             <Chat 
                name="Mark"
                message="Lets play"
                timestamp="5 minutes ago"
                profilePic="https://images.pexels.com/photos/275033/pexels-photo-275033.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            />
             <Chat 
                name="James"
                message="Come over"
                timestamp="21 minutes ago"
                profilePic="https://images.pexels.com/photos/274506/pexels-photo-274506.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
            />
             <Chat 
                name="Maggie"
                message="Tomorrow maybe"
                timestamp="27 minutes ago"
                profilePic="https://images.pexels.com/photos/820673/pexels-photo-820673.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            />
        </div>
    );
}

export default Chats;
